<template>
  <div class="compress-image-tip">
    <div class="compress-image-tip__mask" />
    <div class="compress-image-tip__panel">
      <div class="compress-image-tip__header">
        <icon-warning class="compress-image-tip__icon" />
        <div class="compress-image-tip__text">
          <div class="compress-image-tip__title">图片大小超过 {{ limit }}MB，不能直接上传</div>
          <div v-if="fileName" class="compress-image-tip__file" :title="fileName">{{ fileName }}</div>
        </div>
      </div>
      <div class="compress-image-tip__actions">
        <base-button size="small" @click.stop="cancel">{{ cancelText }}</base-button>
        <base-button size="small" type="primary" @click.stop="confirm">{{ confirmText }}</base-button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '~/components/base/BaseButton'
import iconWarning from '@/assets/svg/icon/iconWarning.svg'

export default {
  name: 'CompressImageTip',
  components: {
    BaseButton,
    iconWarning
  },
  props: {
    limit: {
      type: Number,
      default: 2
    },
    fileName: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '不上传'
    },
    confirmText: {
      type: String,
      default: '自动压缩后上传'
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.compress-image-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  &__panel {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 400px;
    padding: 24px;
    background: var(--bg-color-overlay);
    border: 1px solid var(--border-color-base);
    border-radius: 16px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: var(--shadow-lg);
  }

  &__header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  &__icon {
    flex-shrink: 0;
  }

  &__text {
    flex: 1;
    min-width: 0;
  }

  &__title {
    color: var(--text-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
  }

  &__file {
    margin-top: 6px;
    color: var(--text-secondary);
    font-size: 12px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: 20px;

    /deep/ .base-btn {
      margin-left: 0;
      font-size: 11px;
    }
  }
}
</style>
